import React from 'react';
import { useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import LinkFilledIcon from '@atlaskit/icon/glyph/link-filled';
import Tooltip from '@atlaskit/tooltip';
import { messages } from './messages';
export const LinkedFieldIcon = ({
  fieldName
}) => {
  const {
    formatMessage
  } = useIntl();
  const message = fieldName ? formatMessage(messages.tooltip, {
    fieldName
  }) : formatMessage(messages.unknownField);
  return /*#__PURE__*/React.createElement(Tooltip, {
    position: "top",
    content: message
  }, tooltipProps => /*#__PURE__*/React.createElement("span", tooltipProps, /*#__PURE__*/React.createElement(LinkFilledIcon, {
    size: "small",
    label: "Linked field"
  })));
};